import React, { Component } from "react";
import Loader from "./Loader";
class AccommodationsLoader extends Component {
  render() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        {/* card for accomodation */}
        <div className="card min-h-200">
          <div className="card-body row no-gutters accommodation-list p-0">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
              <Loader width="350" height="300" />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
              <div className="row content">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                  <div className="justify-content-around align-items-start">
                    <div className="title-description">
                      <div className="title">
                        <Loader width="350" height="50" />
                      </div>
                      <div className="description">
                        <Loader width="350" height="20" />
                      </div>
                    </div>
                    <div className="bedspace-info">
                      {/* <span>
                          {" "}
                          <img
                            src={require("../assets/bed-space.svg")}
                            alt="bed icon"
                          />
                        </span>{" "} */}
                      <span className="bedspace-info-text">
                        {" "}
                        <Loader width="35" height="15" />{" "}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <div className="price-info ">
                    <div className="price-duration">
                      <div className="price">
                        <Loader width="350" height="30" />
                      </div>
                      <div className="duration">
                        <Loader width="350" height="20" />
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="duration">
                        <Loader width="350" height="100" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*  end card for accomdation */}
      </div>
    );
  }
}

export default AccommodationsLoader;
